import DataTable from "react-data-table-component";
import { Card, Col,CardBody } from "reactstrap";
import { SCROLL_VERTICAL_COLUMN, SCROLL_VERTICAL_DATA } from "../../../../Data/DataTable/ScrollVertical";
import ScrollVaerticalHeader from "./ScrollVaerticalHeader";

const ScrollVerticalDynamicHeight = () => {
  return (
    <Col sm="12">
      <Card>
        <ScrollVaerticalHeader/>
        <CardBody>
          <div className="table-responsive user-datatable">
            <DataTable data={SCROLL_VERTICAL_DATA} columns={SCROLL_VERTICAL_COLUMN} striped fixedHeader fixedHeaderScrollHeight="40vh" className="display dataTable"/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ScrollVerticalDynamicHeight;
